import React from 'react'
import PropTypes from 'prop-types' // eslint-disable-line import/no-extraneous-dependencies

const Search = ({ onSearch, value }) => (
  <div className="search-item">
    <input
      type="text"
      onChange={onSearch}
      placeholder="Search"
      className="search-field"
      value={value}
    />
    <i className="search-icon" />
  </div>
)

Search.propTypes = {
  onSearch: PropTypes.func,
  value: PropTypes.string,
}

Search.defaultProps = {
  onSearch: () => {},
  value: '',
}

export default Search
